<template>
  <svg
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="translate(0 -1058.52)">
      <rect
        width="60"
        height="60"
        x="2"
        y="1060.52"
        rx="6"
        ry="6"
        fill="#3f51b5"
        style="fill:#4338ca;fill-opacity:1"
      />
      <path
        d="M32.002 1069.52a7.558 7.558 0 0 0-2.937.547 2.144 2.144 0 0 0-1.254 1.38c-2.29 7.914-4.807 16.292-6.966 23.569h-2.494c-.848 0-1.611.509-1.937 1.29l-5.25 12.307a2.099 2.099 0 0 0 1.937 2.907h37.798a2.099 2.099 0 0 0 1.937-2.907l-5.25-12.307a2.099 2.099 0 0 0-1.937-1.29h-2.498c-2.304-7.794-4.89-16.457-6.966-23.566a2.14 2.14 0 0 0-1.355-1.418 8.997 8.997 0 0 0-2.828-.51zm-5.515 9.065c2.924 1.598 8.097 1.6 11.028.01.86 2.889 1.735 5.875 2.488 8.36-5.379 2.026-10.053 2.514-16.016.025.91-2.98 1.726-5.773 2.5-8.394zm15.83 16.183 1.339 4.503c.25.844-.098 1.75-.852 2.211-3.07 1.877-6.98 2.801-10.877 2.84-3.897.038-7.81-.81-10.825-2.902a1.943 1.943 0 0 1-.758-2.149l1.267-4.265c3.042 1.494 12.2 4.458 20.707-.238z"
        fill="#fff"
      />
    </g>
  </svg>
</template>
